import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  get_dp28ag147e4p5cz as get_dp,
  get_px8ok5q0jdway2 as get_px,
  get_rem14pbkv8p42gid as get_rem,
  plus2opbwe063z9pg as plus,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { sizeConstraints2hv7x4j4qpd36 as sizeConstraints } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from './nav/AppDimensions.mjs';
import {
  divkhq3vjih9fcw as div,
  Dimensions32ju1l7z4mh as Dimension,
  Dimension__compareTo_impl_gsceod2qehgbisv77nv as Dimension__compareTo_impl_gsceod,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { Edges2jf5wl855ambv as Edges } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Rect.mjs';
import { Companion_getInstance2xbytizsyx2ps as Companion_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/ViewWrapper.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function space(_this__u8e3s4, value, setup) {
  var tmp;
  if (setup === VOID) {
    tmp = space$lambda;
  } else {
    tmp = setup;
  }
  setup = tmp;
  var tmp_0 = sizeConstraints(_this__u8e3s4, _this__u8e3s4.wb8_1 ? get_dp(1) : value, VOID, _this__u8e3s4.wb8_1 ? value : get_dp(1));
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Space())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  setup(view);
  _this__u8e3s4.hbb(p, view);
  return _this__u8e3s4.lbb(tmp_0, view);
}
var Indent_Full_instance;
var Indent_Section_instance;
var Indent_HalfSection_instance;
var Indent_CenteredSection_instance;
var Indent_Tab_instance;
var Indent_entriesInitialized;
function Indent_initEntries() {
  if (Indent_entriesInitialized)
    return Unit_instance;
  Indent_entriesInitialized = true;
  Indent_Full_instance = Indent().wi1('Full', 0, get_AppDimensions().yg1_1, get_AppDimensions().ag2_1);
  Indent_Section_instance = Indent().wi1('Section', 1, get_AppDimensions().zg1_1, get_px(0));
  Indent_HalfSection_instance = Indent().wi1('HalfSection', 2, div(get_AppDimensions().zg1_1, 2), get_px(0));
  Indent_CenteredSection_instance = Indent().wi1('CenteredSection', 3, get_AppDimensions().zg1_1, get_AppDimensions().zg1_1);
  Indent_Tab_instance = Indent().wi1('Tab', 4, get_AppDimensions().cg2_1, get_px(0));
}
var IndentClass;
function Indent() {
  if (IndentClass === VOID) {
    class $ extends Enum() {
      static wi1(name, ordinal, before, after) {
        var $this = this.c4(name, ordinal);
        $this.agr_1 = before;
        $this.bgr_1 = after;
        return $this;
      }
    }
    initMetadataForClass($, 'Indent');
    IndentClass = $;
  }
  return IndentClass;
}
function indented(_this__u8e3s4, beforeSpace, afterSpace) {
  afterSpace = afterSpace === VOID ? get_px(0) : afterSpace;
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.beforeNextElementSetup' call
  var prev = _this__u8e3s4.dbb_1;
  var tmp = _this__u8e3s4;
  tmp.dbb_1 = (_this__u8e3s4) => {
    var tmp0_safe_receiver = prev;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver(_this__u8e3s4);
    // Inline function 'kotlin.let' call
    var it = beforeSpace;
    var tmp0_left = Dimension__compareTo_impl_gsceod(it, get_px(0)) <= 0 ? it : plus(it, get_rem(0.7));
    // Inline function 'kotlin.let' call
    var it_0 = afterSpace;
    var tmp1_right = Dimension__compareTo_impl_gsceod(it_0, get_px(0)) <= 0 ? it_0 : plus(it_0, get_rem(0.7));
    var tmp2_top = get_px(0);
    var tmp3_bottom = get_px(0);
    _this__u8e3s4.jba(Edges().dd0(tmp0_left, tmp2_top, tmp1_right, tmp3_bottom));
    return Unit_instance;
  };
  return Companion_getInstance();
}
function indentedExact(_this__u8e3s4, beforeSpace, afterSpace) {
  afterSpace = afterSpace === VOID ? get_px(0) : afterSpace;
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.beforeNextElementSetup' call
  var prev = _this__u8e3s4.dbb_1;
  var tmp = _this__u8e3s4;
  tmp.dbb_1 = (_this__u8e3s4) => {
    var tmp0_safe_receiver = prev;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver(_this__u8e3s4);
    var tmp0_top = get_px(0);
    var tmp1_bottom = get_px(0);
    _this__u8e3s4.jba(Edges().dd0(beforeSpace, tmp0_top, afterSpace, tmp1_bottom));
    return Unit_instance;
  };
  return Companion_getInstance();
}
function space$lambda(_this__u8e3s4) {
  return Unit_instance;
}
function Indent_Section_getInstance() {
  Indent_initEntries();
  return Indent_Section_instance;
}
function Indent_HalfSection_getInstance() {
  Indent_initEntries();
  return Indent_HalfSection_instance;
}
function Indent_CenteredSection_getInstance() {
  Indent_initEntries();
  return Indent_CenteredSection_instance;
}
function Indent_Tab_getInstance() {
  Indent_initEntries();
  return Indent_Tab_instance;
}
//region block: exports
export {
  indentedExact as indentedExact2f1prym8qlwxs,
  indented as indented3383b46h9g40w,
  space as space2ppi73m2qk1br,
  Indent_CenteredSection_getInstance as Indent_CenteredSection_getInstance372tfy97032sl,
  Indent_HalfSection_getInstance as Indent_HalfSection_getInstance3e9u4kbpkw4rx,
  Indent_Section_getInstance as Indent_Section_getInstance2f8fy630t595n,
  Indent_Tab_getInstance as Indent_Tab_getInstance17jhdl82d14zt,
};
//endregion

//# sourceMappingURL=space.mjs.map
